<template>
  <div class="wrapper" :class="{ 'first-tab-selected': firstTabSelected }">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  border-radius: 32px;
  background-color: #e7e8ed;
}

.first-tab-selected {
  border-top-left-radius: 0;
}
</style>

<script>
export default {
  props: {
    tabDefinitions: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    firstTabSelected() {
      return this.tabDefinitions.findIndex(tab => tab.id === this.value) === 0;
    }
  }
};
</script>
